import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { getAccountsTotals, getMonthlyInvoiceTotals } from "../../services/apiClient.js";
import WorkflowReport from "./WorkflowReport.jsx";

// RDR Accounts, live: this month's invoice totals (ex GST) by division with
// Quote Fees split out (legacy Monthly Invoice Totals), then the Accounts rule
// lines from the shared engine.

const money = (v) =>
  v.toLocaleString("en-NZ", { style: "currency", currency: "NZD", maximumFractionDigits: 0 });

function RdrAccountsReport() {
  const [totals, setTotals] = useState(null);
  // Monthly history (Karen r1): collapsed by default, loads on first open.
  const [historyOpen, setHistoryOpen] = useState(false);
  const [history, setHistory] = useState(null);

  useEffect(() => {
    getAccountsTotals().then(setTotals).catch(() => {});
  }, []);

  useEffect(() => {
    if (!historyOpen || history) return;
    getMonthlyInvoiceTotals(12).then(setHistory).catch(() => setHistory([]));
  }, [historyOpen, history]);

  const monthLabel = (m) => {
    const [y, mo] = m.split("-");
    return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString("en-NZ", { month: "short", year: "numeric" });
  };

  return (
    <>
      {totals && totals.length > 0 ? (
        <div className="placeholder-panel">
          <div className="d-flex flex-wrap column-gap-4 row-gap-2">
            <span className="text-uppercase fw-semibold small text-muted align-self-center" style={{ letterSpacing: "0.06em" }}>
              Invoiced this month (ex GST)
            </span>
            {totals.map((t) => (
              <div key={`${t.division}:${t.is_quote_fee}`} className="text-nowrap">
                <div className="text-muted text-uppercase" style={{ fontSize: "0.62rem", letterSpacing: "0.06em" }}>
                  {t.division}{t.is_quote_fee ? " · Quote Fees" : ""}
                </div>
                <div className="fs-6 fw-semibold lh-1">
                  {money(t.total)}
                  <span className="text-muted fw-normal ms-1" style={{ fontSize: "0.72rem" }}>({t.n})</span>
                </div>
              </div>
            ))}
            <Button
              size="sm" variant="outline-secondary"
              className="rounded-pill py-0 align-self-center ms-auto"
              style={{ fontSize: "0.78rem", lineHeight: 1.8 }}
              onClick={() => setHistoryOpen((o) => !o)}
            >
              {historyOpen ? "Hide monthly history" : "Monthly history"}
            </Button>
          </div>
          {historyOpen ? (
            history == null ? (
              <p className="text-muted small pt-2 mb-0">Loading…</p>
            ) : (
              <Table striped bordered hover responsive size="sm" className="mt-2 mb-0 align-middle" style={{ maxWidth: 640 }}>
                <thead className="table-surface">
                  <tr>
                    <th>Month</th>
                    <th className="text-end">Invoiced (ex GST)</th>
                    <th className="text-end">Jobs</th>
                    <th className="text-end">Quote Fees (ex GST)</th>
                    <th className="text-end">Jobs</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((r) => (
                    <tr key={r.month}>
                      <td className="text-nowrap">{monthLabel(r.month)}</td>
                      <td className="text-end">{money(r.invoice_total)}</td>
                      <td className="text-end">{r.invoice_jobs}</td>
                      <td className="text-end">{money(r.quote_fee_total)}</td>
                      <td className="text-end">{r.quote_fee_jobs}</td>
                    </tr>
                  ))}
                  {history.length === 0 ? (
                    <tr><td colSpan={5} className="text-center text-muted">No invoices yet.</td></tr>
                  ) : null}
                </tbody>
              </Table>
            )
          ) : null}
        </div>
      ) : null}
      <WorkflowReport group="accounts" />
    </>
  );
}

export default RdrAccountsReport;
